import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IDetailList,ISaleSoList, ISaleSoFields, ISaleSoDetail, ISaleSoSearch, Ids, Detailed, ISaleSoSettleAndWhConfirm } from "./saleSoTypes"
class SaleSoService {
    async page(searchVo: ISaleSoSearch) {
        const apiUrl = "/vrm-sa/sale/findPage";
        return await httpRequest.post<ISaleSoList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/sale/findById/${id}`;
        return await httpRequest.get<ISaleSoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleSoFields) {
        const apiUrl = "/vrm-sa/sale/insert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleSoFields) {
        const apiUrl = "/vrm-sa/sale/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: ISaleSoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/sale/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm-sa/sale/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: ISaleSoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/sale/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/sale/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/vrm-sa/sale/detail/downloadTpl";
        return await httpRequest.getFile(apiUrl);
    }
    //打印
    async printing(params: object) {
        const apiUrl = "/vrm-sa/sale/printing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售单批量导出
    async export(params: ISaleSoSearch) {
        const apiUrl = "/vrm-sa/sale/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    //销售单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/sale/detailsExport";
        return await httpRequest.postFile(apiUrl, params);
    }
}

export const saleSoService = new SaleSoService();